var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentBlackSpeechBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "oval-black-speech-bubble",
    width: 21.75,
    height: 18.881,
    viewBox: "0 0 21.75 18.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#b9c9d9}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    d: "M.5 11.662a7.943 7.943 0 0 0 2.549 5.713v3.776l3.776-1.444a12.338 12.338 0 0 0 4.249.745c5.839 0 10.573-3.935 10.573-8.788s-4.735-8.79-10.574-8.79S.5 6.809.5 11.662z",
    className: "cls-1",
    transform: "translate(-0.198 -2.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    d: "M2.851 21.255a.3.3 0 0 0 .108-.02l3.671-1.4a12.611 12.611 0 0 0 4.246.725c6 0 10.875-4.079 10.875-9.091s-4.879-9.095-10.876-9.095S0 6.452 0 11.465A8.249 8.249 0 0 0 2.549 17.3v3.649a.3.3 0 0 0 .3.3zm3.776-2.049a.3.3 0 0 0-.108.02l-3.366 1.288v-3.337a.3.3 0 0 0-.092-.217A7.672 7.672 0 0 1 .6 11.465c0-4.679 4.608-8.486 10.271-8.486s10.27 3.807 10.27 8.487-4.608 8.487-10.271 8.487a11.994 11.994 0 0 1-4.145-.726.3.3 0 0 0-.098-.02z",
    className: "cls-1",
    transform: "translate(0 -2.374)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentBlackSpeechBubble);
export default __webpack_public_path__ + "static/media/commentBlackSpeechBubble.93c8104a0a4a08ee89f5b01540ab8b91.svg";
export { ForwardRef as ReactComponent };